module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gCBnp"))).then(() => parcelRequire('hEqeo'));